export const PROFILE_ROUTINE_APPROVED = "PROFILE_ROUTINE_APPROVED";
export const PROFILE_ROUTINE_SNOOZED = "PROFILE_ROUTINE_SNOOZED";
